import { When } from 'react-if';

import Card from '@/components/@base/card';
import RegularList from '@/components/@base/regularList';
import DiscountedCodesCard from '@/components/shared/components/developer-discount-codes/discounted-codes-card';

import VendorVoucherModel from '@/models/vendor-voucher.model';

type Props = {
  products: VendorVoucherModel[];
};

export default function DeveloperDiscountCodes({ products }: Props) {
  if (!(products?.length > 0)) {
    return null;
  }
  return (
    <When condition={products?.length > 0}>
      <Card
        noBorder
        className='relative z-0 justify-start divide-y divide-[#EDEEF2] self-start p-6 md:mx-6 md:divide-y-0 lg:mx-0 lg:p-8'
      >
        <RegularList
          items={products}
          itemComponent={DiscountedCodesCard}
          resoucreName='data'
          keyExtractor={(item: VendorVoucherModel) => item.id}
        />
      </Card>
    </When>
  );
}
